const backgroundColorClasses = [
  '!bg-red-300',
  '!bg-orange-300',
  '!bg-yellow-300',
  '!bg-green-300',
  '!bg-teal-300',
  '!bg-rose-300',
  '!bg-indigo-300',
  '!bg-purple-300',
  '!bg-pink-300',
  '!bg-emerald-300',
  '!bg-sky-300',
  '!bg-violet-300',
  '!bg-lime-300',
  '!bg-teal-400',
  '!bg-blue-300',
  '!bg-indigo-400',
  '!bg-purple-400',
];

/**
 * Generates a CSS class name for a user's avatar background color based on their name.
 * @param name The name of the user.
 * @returns The CSS class name for the user's avatar background color.
 */
export const generateAvatarBackgroundColorClassName = (
  name: string,
): string => {
  const hash = name
    .split('')
    .reduce((accumulatedHash, char) => accumulatedHash + char.charCodeAt(0), 0);
  const index = hash % backgroundColorClasses.length;
  return backgroundColorClasses[index];
};

/**
 * Generates the URL for a user's avatar based on their identity service ID.
 * @param user The user object containing the identityServiceId.
 * @returns The constructed URL for the user's avatar.
 */
export const getAvatarUrl = (user: { identityServiceId?: string }): string => {
  if (!user?.identityServiceId) return null;
  const baseUrlMatch = import.meta.env.VITE_ID_SERVICE_URL.match(
    /^(.+?)\/ui\//,
  );
  if (!baseUrlMatch) {
    throw new Error('Invalid ID service URL format.');
  }
  const baseUrl = baseUrlMatch[1];
  return `${baseUrl}/users/${user?.identityServiceId}/avatar`;
};
